/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-30 10:27:17
 * @LastEditors: Andy
 * @LastEditTime: 2022-11-30 11:39:36
 */
import XSelectTree from './xSelectTree.vue'

const xSelectTree = {
  install(Vue) {
    Vue.component(XSelectTree.name, XSelectTree)
  }
}
export default xSelectTree
